import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IPwaUpdateDialogData } from '../../../interfaces/pwa-update.interfaces';

@Component({
    selector: 'app-pwa-update-dialog',
    templateUrl: './pwa-update-dialog.component.html',
    styleUrls: ['./pwa-update-dialog.component.scss'],
    standalone: false,
})
export class PwaUpdateDialogComponent {
    public constructor(
        @Inject(MAT_DIALOG_DATA)
        public readonly data: IPwaUpdateDialogData,
    ) {}
}
